import React from "react"

import QuoteSectionDesktop from "./QuoteSectionDesktop"
import QuoteSectionMobile from "./QuoteSectionMobile"

const QuoteSection = ({ section, theme, highlightedField, viewMode = "", deviceType = "desktop" }) => {
  // If viewMode is explicitly set (from preview), use that to determine which component to show
  if (viewMode === "mobile") {
    return <QuoteSectionMobile section={section} theme={theme} highlightedField={highlightedField} />
  }

  if (viewMode === "desktop") {
    return <QuoteSectionDesktop section={section} theme={theme} highlightedField={highlightedField} />
  }

  // Use server-side device detection for public pages
  if (deviceType === "mobile") {
    return <QuoteSectionMobile section={section} theme={theme} highlightedField={highlightedField} />
  }

  // Default to desktop for desktop devices
  return <QuoteSectionDesktop section={section} theme={theme} highlightedField={highlightedField} />
}

export default QuoteSection
